import styled from 'styled-components';

export const Body = styled.form`
  display: flex;
`;
export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 0 1rem 0;

  .subHeader {
    display: flex;
    align-items: flex-end;

    h1 {
      color: ${({ theme }) => theme.colors.tertiary_500};
      font-size: 22px;
      margin: 0;
      width: 100%;
      font-weight: medium;
      margin-left: 0.5rem;
    }

    svg {
      width: 1.8rem;
      height: 1.8rem;
      fill: ${({ theme }) => theme.colors.tertiary_500};
    }
  }

  .close-div {
    padding: 0;
    height: 20px;

    button {
      color: #fff;
      background-color: ${({ theme }) => theme.colors.tertiary_500};
      width: 20px;
      height: 19px;
      border-radius: 100%;
      padding: 0;
      border: none;

      :hover {
        cursor: pointer;
      }
    }
  }
`;

export const ContentModal = styled.div`
  textarea {
    width: -webkit-fill-available;
    min-height: 10rem;
    max-height: 10rem;
    padding: 0.5rem;
    font-size: 1rem;
    border-radius: 0.8rem;
    color: ${({ theme }) => theme.colors.text_gray};

    ::-webkit-scrollbar {
      width: 8px;
      background-color: ${({ theme }) => theme.colors.background_white};
      border-radius: 10px;
    }

    ::-webkit-scrollbar:horizontal {
      height: 5px;
    }

    ::-webkit-scrollbar-track,
    ::-webkit-scrollbar-track-horizontal {
      border-radius: 10px;
    }

    ::-webkit-scrollbar-thumb,
    ::-webkit-scrollbar-thumb:horizontal {
      background-color: ${({ theme }) => theme.colors.tertiary_500};
      border-radius: 10px;
    }
  }

  .fieldError {
    color: red;
    display: flex;
    align-items: center;
    font-size: 1rem;
    flex-wrap: nowrap;
    padding-bottom: 1rem;

    svg {
      margin-right: 2px;
      font-size: 1rem;
      padding-bottom: 0.1rem;
      fill: ${({ theme }) => theme.colors.error} !important;
    }
  }
`;
export const ContentButtons = styled.div`
  display: flex;
  justify-content: space-around;
  width: 100%;
  margin-top: 0.5rem;
`;
